import dayjs from 'dayjs';
import * as Yup from 'yup'
export const phoneNumberRegex = /^\d{10}$/;
export const zipCodeRegex = /^[A-Za-z0-9]{5,6}$/;
export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/;

export const CUSTOMER_TYPE = {
  label: "User Type",
  validation: {
    required: "User Type is required",
  }
}

export const DIAGNOSTICS_TYPE = {
  label: "Diagnostics Type",
  validation: {
    required: "Hospital/Diagnostics Type is required",
  }
}

export const NAME = {
  label: "Name",
  validation: {
    required: "Name is required",
  }
}

export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email is required",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  }
}

export const CONTACT_NUMBER = {
  label: "Contact Number",
  validation: {
    required: "Contact Number is required",
    valid: "Contact Number must be of 10 digits",
  },
  regex: phoneNumberRegex,
};

export const WHATSAPP_NUMBER = {
  label: "Whatsapp Number",
  validation: {
    valid: "Whatsapp Number must be of 10 digits",
  },
  regex: phoneNumberRegex,
};

export const SPECIALITY = {
  label: "Speciality",
  validation: {
    required: "Speciality is required",
  },
};

export const ZIP_CODE = {
  label: "Zip Code",
  validation: {
    required: "Zip Code is required",
    valid: "Zip Code must be a valid alphanumeric string with 5 or 6 characters",
    minLength: {
      value: 5,
      message: "Zip Code must be at least 5 digits",
    },
    maxLength: {
      value: 6,
      message: "Zip Code must not exceed 6 digits",
    },
  },
  regex: zipCodeRegex
};

export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "Date must be in the format DD/MM/YYYY",
    required: "DOB is required"
  },
  regex: dateRegex,
};

export const SUPER_ADMIN_NAME = {
  label: "Super Admin Name",
  validation: {
    required: "Super Admin Name is required",
  }
}

export const SIGNATURE = {
  label: "Signature",
  validation: {
    required: "Signature is required",
  }
}

export const SUPER_ADMIN_EMAIL = {
  label: "Super Admin Email",
  validation: {
    required: "Super Admin Email is required",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  }
}

export const SUPER_ADMIN_PHONE_NUMBER = {
  label: "Super Admin Phone Number",
  validation: {
    required: "Contact Number is required",
    valid: "Contact Number must be of 10 digits",
  },
  regex: phoneNumberRegex,
}

export const SUPER_ADMIN_WHATSAPP_NUMBER = {
  label: "Super Admin Whatsapp Number",
  validation: {
    required: "Whatsapp Number is required",
    valid: "Whatsapp Number must be of 10 digits",
  },
  regex: phoneNumberRegex,
}

const role = sessionStorage?.getItem("role")

export const teleRadiologySchema=Yup.object().shape({
    customerType: Yup.string().required(CUSTOMER_TYPE.validation.required),
    diagnosticsType: Yup.string().required(DIAGNOSTICS_TYPE.validation.required),
    name: Yup.string().required(NAME.validation.required),
    email: Yup.string().email('Invalid email format').required(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
      return !value || value === value.toLowerCase();
    }),
    address:Yup.string(),
    zipCode:Yup.string()
    .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
    .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
    .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
    country:Yup.string(),
    state:Yup.string(),
    city:Yup.string(),
    website:Yup.string(),
    contactNumberCountryCode:Yup.string().required(),
    contactNumber: Yup.string().required(CONTACT_NUMBER.validation.required).matches(CONTACT_NUMBER.regex, CONTACT_NUMBER.validation.valid),
    whatsappCountryCode:Yup.string(),
    whatsappNumber:Yup.string().matches(WHATSAPP_NUMBER.regex, WHATSAPP_NUMBER.validation.valid),
    sameAsContact:Yup.boolean(),
    emergencyContactNumberCountryCode:Yup.string(),
    emergencyContactNumber:Yup.string(),
    radiologistNumber:Yup.string(),
    specialitites: Yup.array().required(SPECIALITY.validation.required).test('is-valid', SPECIALITY.validation.required, (value) => {
      console.log('Validating specialties:', value);
      return value && value.length > 0;
    }),
    // Super Admin Details
    superAdminName: Yup.string().required(SUPER_ADMIN_NAME.validation.required),
    superAdminEmail: Yup.string().email('Invalid email format').required(SUPER_ADMIN_EMAIL.validation.required).test('no-uppercase', SUPER_ADMIN_EMAIL.validation.invalidCaps, value => {
      return !value || value === value.toLowerCase();
    }),
    signature: role !== "Superadmin" ? Yup.string().required(SIGNATURE.validation.required) : null,
    superAdminContactNumberCountryCode:Yup.string().required(),
    superAdminPhoneNumber: Yup.string().required(SUPER_ADMIN_PHONE_NUMBER.validation.required).matches(SUPER_ADMIN_PHONE_NUMBER.regex, SUPER_ADMIN_PHONE_NUMBER.validation.valid),
    superAdminWhatsappNumberCountryCode:Yup.string(),
    superAdminWhatsappNumber:Yup.string().required(SUPER_ADMIN_WHATSAPP_NUMBER.validation.required).matches(SUPER_ADMIN_WHATSAPP_NUMBER.regex, SUPER_ADMIN_WHATSAPP_NUMBER.validation.valid),
    superAdminSameAsContact:Yup.boolean(),
  })
